import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import LoginScreen from './pages/sign/Login';
import TableReservation from './pages/tableReservation/Tablereservation';
import Settings from './pages/settings/Settings';
import RestaurantEditor from './pages/restaurantEditor/Restauranteditor';
import SignupScreen from './pages/sign/Signup';
import Cookies from "js-cookie";
import useDefaults from "./hooks/useDefaults";
import MailVerifyScreen from "./pages/sign/MailVerifiyScreen";
import useInfo from "./hooks/useInfo";
import useAPI from "./hooks/useAPI";
import PasswordRestoreScreen from "./pages/sign/PasswordRestore";
import ContactScreen from "./pages/contact/ContactScreen";
import StatisticScreen from "./pages/statistic/StatisticScreen";
import LockOverlay from "./components/lock/LockOverlay";
import LoadingSpinner from "./components/loading/LoadingSpinner";

 function PrivateRoute({ element }) {
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const { defaultValues } = useDefaults();

    useEffect(() => {
        localStorage.removeItem('defaultValues');
    }, []);

    useEffect(() => {
        const checkAuth = async () => {
            const token = Cookies.get("token");
            if (!token) {
                setIsAuthenticated(false);
            } else {
                setIsAuthenticated(true);
            }
        };

        checkAuth();
    }, []);

    if (isAuthenticated === null) {
        return <div className={"mt-4"} style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            <LoadingSpinner/>
        </div>;
    }

     return isAuthenticated ? element : <Navigate to="/login"/>;
 }

function App() {
    const {renderInfo, hideInfo} = useInfo();
    const {sendRequest} = useAPI();
    const [showPinOverlay, setShowPinOverlay] = useState(true);

    useEffect(() => {
        checkDemo();
    }, []);

    const checkDemo = () => {
        if (!Cookies.get("token")) return;

        let restaurantId = null;
        sendRequest("restaurant").then((data) => {
            if (data?.response.status === 200) {
                restaurantId = data.data.id;
                if (restaurantId === 1) {
                    renderInfo("Du befindest dich im Demo Modus. Du kannst keine Änderungen vornehmen.");
                } else {
                    hideInfo();
                }
            } else {
                hideInfo();
            }
        }).catch(() => {
            hideInfo();
            Cookies.remove("token");
        });
    };

    return (
        <Router>
            <div className="App">
                <LockOverlay show={showPinOverlay} setShow={setShowPinOverlay} />
                <header className="App-header" style={{ backgroundColor: 'white' }}>
                    <Routes>
                        <Route path="/" element={<Navigate to="/reservation" />} />
                        <Route path="/login" element={<LoginScreen checkDemo={checkDemo} />} />
                        <Route path="/signup" element={<SignupScreen checkDemo={checkDemo} />} />
                        <Route path="/restorePassword" element={<PasswordRestoreScreen checkDemo={checkDemo} />} />
                        <Route path="/mailverify" element={<MailVerifyScreen checkDemo={checkDemo} />} />
                        <Route path="/reservation" element={<PrivateRoute element={<TableReservation />} />} />
                        <Route path="/birdperspective" element={<PrivateRoute element={<TableReservation />} />} />
                        <Route path="/restauranteditor" element={<PrivateRoute element={<RestaurantEditor />} />} />
                        <Route path="/settings" element={<PrivateRoute element={<Settings />} />} />
                        <Route path="/statistics" element={<PrivateRoute element={<StatisticScreen />} />} />
                        <Route path="/contact" element={<PrivateRoute element={<ContactScreen />} />} />
                        <Route path="/mailverify" element={<PrivateRoute element={<MailVerifyScreen checkDemo={checkDemo} />} />} />
                        <Route path="/restorePassword" element={<PrivateRoute element={<PasswordRestoreScreen />} />} />
                    </Routes>
                </header>
            </div>
        </Router>
    );
}

export default App;
